import { useNavigate } from 'react-router-dom'
import { AlertCircle, CreditCard, ChevronRight } from 'lucide-react'
import './SubscriptionExpiredModal.css'

export default function SubscriptionExpiredModal({ onClose }) {
  const navigate = useNavigate()

  function handleRenew() {
    navigate('/dashboard/billing')
    if (onClose) onClose()
  }

  return (
    <div className="expired-modal-overlay">
      <div className="expired-modal-content">
        <div className="expired-icon-wrapper">
          <AlertCircle size={48} />
          <div className="expired-icon-ripple"></div>
        </div>

        <h2>Subscription Expired</h2>
        <p>
          Your plan has expired and your vCard is no longer visible to the public. 
          Renew your subscription to restore full access immediately.
        </p>

        <div className="expired-features">
          <div className="expired-feature-item">
            <span>🚫 Public Profile Hidden</span>
          </div>
          <div className="expired-feature-item">
            <span>🚫 Editing Locked</span>
          </div>
          <div className="expired-feature-item">
            <span>🚫 Analytics Paused</span>
          </div>
        </div>

        <button className="renew-btn-primary" onClick={handleRenew}>
          <span>Renew Subscription</span>
          <ChevronRight size={20} />
        </button>
        
        <button className="contact-support-btn">
          Contact Support
        </button>
      </div>
    </div>
  )
}
